import React, { useState, useEffect } from "react";
import SecPlateEdit from "../components/Plates/SecPlateEdit";
import UserSidepanel from "../shared/userSidepanel";
import { useParams } from "react-router";
import { getPlateDetails } from "../actions/ticket";
import { checkDriverVehicle } from "../actions/site";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
const EditPlate = () => {
  const { id } = useParams();
  const [plate, setPlate] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // State List
    const loadDriver = async () => {
      try {
        const data = await getPlateDetails({
          id: id,
        });
        if (data.status == 200) {
          setPlate(data.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadDriver();
  }, [id]);
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispatch(async () => {
        try {
          const data = await checkDriverVehicle();
          if (data.status == 200) {
            if (data.step == 1) {
              return navigate("/add-driver");
            } else if (data.step == 2) {
              return navigate("/add-plate");
            }
          } else {
            return navigate("/add-driver");
          }
        } catch (err) {
          console.log(err.message);
        }
      });
    }
  }, [dispatch, window.location.pathname]);
  return (
    <section className="sec-panel login-part-pages">
      <div className="container">
        <div className="row user-panel-menus">
          <div className="left-sidebar">
            <UserSidepanel />
          </div>
          <div className="right-sidebar">
            <SecPlateEdit id={id} plate={plate} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditPlate;
